import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { Emails, Email } from '../mailbox.types';

@Injectable({
  providedIn: 'root',
})
export class MailboxService {
  /**
   * Constructor
   *
   * @param {HttpClient} _httpClient
   */
  constructor(private _httpClient: HttpClient) {}

  getMails(accountId: number, relatedToId: number, relatedToType = 'Contact', page = '1'): Observable<Emails> {
    let params = {};
    if (relatedToType === 'Contact') {
      params = {
        contact_id: String(relatedToId),
        page: page,
      };
    } else if (relatedToType === 'Project') {
      params = {
        project_id: String(relatedToId),
        page: page,
      };
    } else if (relatedToType === 'Company') {
      params = {
        company_id: String(relatedToId),
        page: page,
      };
    }
    return this._httpClient
      .get<Emails>(`emails`, {
        params: params,
      })
      .pipe(take(1));
  }

  refreshMails(accountId: number): Observable<void> {
    return this._httpClient.get<void>(`emails/refresh`).pipe(take(1));
  }

  sendMail(
    accountId: number,
    to: any[],
    subject: string,
    body: string,
    cc: any[] = [],
    bcc: any[] = [],
  ): Observable<void> {
    return this._httpClient
      .post<void>(`emails/send`, {
        to: to,
        subject: subject,
        body: body,
        cc: cc,
        bcc: bcc,
      })
      .pipe(take(1));
  }

  deleteMail(accountId: number, id: number): Observable<Email> {
    return this._httpClient.delete<Email>(`emails/${id}`).pipe(take(1));
  }
}
